import React, { useState } from "react";
import styles from "./CAGRCalculator.module.css";

const CAGRCalculator = () => {
  const [startValue, setStartValue] = useState("");
  const [endValue, setEndValue] = useState("");
  const [years, setYears] = useState("");
  const [cagr, setCagr] = useState(null);
  const [growthData, setGrowthData] = useState([]);
  const [error, setError] = useState("");

  const formatIndianNumber = (num) => {
    return Number(num).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const calculateCAGR = () => {
    setError("");
    setCagr(null);
    setGrowthData([]);

    // Input validation
    if (!startValue || !endValue || !years) {
      setError("Please enter all fields.");
      return;
    }

    if (startValue <= 0 || endValue <= 0 || years <= 0) {
      setError("All values must be greater than zero.");
      return;
    }

    try {
      const cagrValue =
        (Math.pow(endValue / startValue, 1 / years) - 1) * 100;
      setCagr(cagrValue);

      const yearlyGrowth = [];
      for (let i = 0; i <= years; i++) {
        const value = startValue * Math.pow(1 + cagrValue / 100, i);
        yearlyGrowth.push({ year: i, value });
      }
      setGrowthData(yearlyGrowth);
    } catch (err) {
      setError("An error occurred while calculating CAGR.");
    }
  };

  return (
    <div className={styles.container}>
      
      <div className={styles.card}>

        <h1 className={styles.title}>CAGR Calculator</h1>

        <div className={styles.inputGroup}>

          <div>
            <label>Start Value</label>
            <input
              type="number"
              value={startValue}
              className={styles.input}
              onChange={(e) => setStartValue(e.target.value)}
              placeholder="e.g. 12000"
            />
          </div>

          <div>
            <label>End Value</label>
            <input
              type="number"
              value={endValue}
              className={styles.input}
              onChange={(e) => setEndValue(e.target.value)}
              placeholder="e.g. 25000"
            />
          </div>

          <div>
            <label>Number of Years</label>
            <input
              type="number"
              value={years}
              className={styles.input}
              onChange={(e) => setYears(e.target.value)}
              placeholder="e.g. 20"
            />
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <button type="submit" onClick={calculateCAGR}>Calculate</button>
        </div>

        {error && <p className={styles.error}>{error}</p>}

        {cagr !== null && (
          <>
            <h3 className={styles.result}>
              Compound Annual Growth Rate (CAGR):{" "}
              <span>{cagr.toFixed(2)}%</span>
            </h3>

            <div className={styles.growthContainer}>
              <div className={`${styles.growthRow} ${styles.headerRow}`}>
                <div className={styles.yearCol}>Year</div>
                <div className={styles.valueCol}>Value</div>
              </div>

              <div className={styles.growthDataContainer} >
                {growthData.map((item) => (
                  <div key={item.year} className={styles.growthRow}>
                    <div className={styles.yearCol}>{item.year}</div>
                    <div className={styles.valueCol}>
                      {formatIndianNumber(item.value)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CAGRCalculator;
